import { css } from "emotion";

import { colors } from "@cobliteam/base-components/src/styles/colors";

export const card = css`
  display: flex;
  width: 100%;
  border-radius: 5px;
  border: solid 1px ${colors.gray.light};
  background-color: ${colors.white};
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;
  margin-bottom: 10px;

  &:hover {
    cursor: pointer;
    color: ${colors.primary.default};
    border: solid 1px ${colors.primary.default};
  }
  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const selectedCard = css`
  background-color: ${colors.custom.primary05};
  border: solid 1px ${colors.primary.default};
`;

export const routeName = css`
  margin-bottom: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const containerInfo = css`
  margin: 0 20px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;
export const icon = css`
  margin-right: 10px;
  height: 12px;
`;

export const iconText = css`
  display: flex;
  align-items: center;
  margin-right: 20px;

  &:last-child {
    margin-right: 0;
  }
`;

export const icons = css`
  display: flex;
  width: 100%;
  color: ${colors.gray.dark};
`;
